export function getdata() {
	var obj = {
		headData: [{
				title: "姓名",
				prop: "nickName",
				width: "80",
				custom: true

			},
			{
				title: "用户名",
				prop: "username",
				width: "80",
				custom: true

			},
			{
				title: "用户角色",
				prop: "role",
				width: 100,
				custom: true

			},
			{
				title: "手机",
				prop: "phoneNumber",
				width: "100",
				custom: true

			},
			{
				title: "邮箱",
				prop: "email",
				width: 160,
			},
			{
				title: "用户状态",
				prop: "userStatus",
				width: "80",
				custom: true
			},
			{
				title: "操作",
				prop: "cz",
				width: "200px",
				fixed: "right",
				custom: true
			}
		],
		headtitle: [{
				label: "基础信息"
			},
			{
				label: "用户角色"
			},
		],
		tableData: [],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		formlistup:[
				{
					prop: "nickName",
					label: "姓名",
					type: "input",
					width: "220px",
					isnotnull: true,
					istosee: false
			
				},
				{
					prop: "username",
					label: "用户名",
					type: "input",
					width: "220px",
					isnotnull: true,
					istosee: false
				},
			
				{
					prop: "phoneNumber",
					label: "手机号",
					type: "input",
					width: "220px",
					istosee: false
				},
				{
					prop: "email",
					label: "邮箱",
					type: "input",
					width: "220px",
					istosee: false
				},
				{
					prop: "userStatus",
					label: "状态",
					type: "radio",
					radioval: [{
							label: "正常",
							value: "0"
						},
						{
							label: "禁用",
							value: "1"
						}
					]
				},
			
		],
		formdataup:{
			username: '',
			nickName: '',
			phoneNumber: '',
			email: '',
			userStatus: 0,
		},
		formlist: [
			{
				prop: "nickName",
				label: "姓名",
				type: "input",
				width: "220px",
				isnotnull: true,
				istosee: false

			}, {
				prop: "password",
				label: "密码",
				type: "input",
				width: "220px",
				ispassword: true,
				isnotnull: true,	
				Customtips: '8位以上包含大小写字母、数字(不连续)、特殊字符',
				Customrules: /^(?!.*(?:(\d)\1|01|12|23|34|45|56|67|78|89|98|87|76|65|54|43|32|21|10))(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F])[\da-zA-Z\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F]{8,}$/
			},
			{
				prop: "passwords",
				label: "确认密码",
				type: "input",
				width: "220px",
				ispassword: true,
				isnotnull: true,
			},
			{
				prop: "username",
				label: "用户名",
				type: "input",
				width: "220px",
				isnotnull: true,
				istosee: false
			},

			{
				prop: "phoneNumber",
				label: "手机号",
				type: "input",
				width: "220px",
				istosee: false
			},
			{
				prop: "email",
				label: "邮箱",
				type: "input",
				width: "220px",
				istosee: false
			},
			{
				prop: "userStatus",
				label: "状态",
				type: "radio",
				radioval: [{
						label: "正常",
						value: "0"
					},
					{
						label: "禁用",
						value: "1"
					}
				]
			},
		],
		formdata: {
			username: '',
			nickName: '',
			password: '',
			passwords: '',
			phoneNumber: '',
			email: '',
			userStatus: 0,
		}
	}
	return obj
}
